export default __webpack_public_path__ + "static/media/stars.59be77e5.svg";